import React, { FC } from 'react';
import styles from './index.module.scss';

const EmptyState: FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className={styles.EmptyState}>{children}</div>
);

export default EmptyState;
